import React from 'react'
import { Box, Typography, DialogTitle } from '@mui/material'
import { styled } from '@mui/material/styles'
import { IconCloseButton } from 'asterX-UI/Buttons'
import PropTypes from 'prop-types'
import InfoOctagonIcon from 'asterX-UI/Icons/InfoOctagonIcon'
import { AlertOctagonIcon } from 'asterX-UI/Icons'
import { ERROR_COLORS, GRAY_COLORS, INFO_COLORS, SUCCESS_COLORS, WARNING_COLORS } from '../colors.constant'

const ModalTitleRoot = styled(DialogTitle)(({ theme }) => ({
  margin: 0,
  position: 'relative',
  padding: '12px 12px 6px 12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end'
}))

const VARIANT_COLORS = {
  info:    INFO_COLORS[600],
  warning: WARNING_COLORS[500],
  error:   ERROR_COLORS[600],
  success: SUCCESS_COLORS[600],
  default: GRAY_COLORS[700]
}

const ModalTitle = ({
                      children,
                      variant = 'info',
                      onClose,
                      disableBtn = false,
                      ...other
                    }) => {
  const color = VARIANT_COLORS[variant] || VARIANT_COLORS.default

  const getIconComponent = () => {
    if (variant === 'info') return <InfoOctagonIcon sx={{ color }} />
    if (variant === 'warning') return <AlertOctagonIcon sx={{ color }} />
    if (variant === 'error') return <InfoOctagonIcon sx={{ color }} />
    if (variant === 'success') return <AlertOctagonIcon sx={{ color }} />
    return null
  }

  return (
    <ModalTitleRoot {...other} sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', wordBreak: 'break-word'
      }}>
        {getIconComponent()}
        <Typography
          variant="subtitle2"
          sx={{ color, fontWeight: 600 }}
        >
          {children}
        </Typography>
      </Box>
      {onClose && !disableBtn && <IconCloseButton aria-label="close" onClick={onClose} />}
    </ModalTitleRoot>
  )
}

ModalTitle.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.any,
  disableBtn: PropTypes.bool,
  variant: PropTypes.string
}

export default ModalTitle
